/** 주문 금액 스탬프 1개 적립 기준 금액 (원) */
export const STAMP_UNIT_AMOUNT = 6900;

/** 주문당 스탬프 최대 1개 정책 적용 시각 (2026-10-20 00:00 KST) */
export const STAMP_CAP_POLICY_STARTED_AT = new Date(
  "2026-10-20T00:00:00+09:00"
);

export type OrderForStampCount = {
  amount: number;
  packId?: number | null;
  isPackConfirmed?: boolean | null;
  isApproved?: boolean | null;
  orderConfirmedAt?: Date | string | null;
  createdAt: Date | string;
  updatedAt?: Date | string | null;
};

function toDate(value: Date | string | null | undefined): Date | null {
  if (!value) {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function resolveOrderConfirmedAt(order: OrderForStampCount): Date | null {
  const orderConfirmedAt = toDate(order.orderConfirmedAt);
  if (orderConfirmedAt) {
    return orderConfirmedAt;
  }

  if (order.packId != null && order.isPackConfirmed) {
    return toDate(order.updatedAt);
  }

  if (order.packId == null && order.isApproved) {
    return toDate(order.createdAt);
  }

  return null;
}

/**
 * 주문 1건에서 적립할 ORDER 스탬프 개수를 반환한다.
 * - 적용 시각 이전: 6,900원당 1개
 * - 적용 시각 이후: 6,900원 이상이면 1개, 주문당 최대 1개
 */
export function getOrderStampCount(order: OrderForStampCount): number {
  const confirmedAt = resolveOrderConfirmedAt(order);
  if (!confirmedAt) {
    return 0;
  }

  if (confirmedAt.getTime() < STAMP_CAP_POLICY_STARTED_AT.getTime()) {
    return Math.floor(order.amount / STAMP_UNIT_AMOUNT);
  }

  return order.amount >= STAMP_UNIT_AMOUNT ? 1 : 0;
}
